// extracted by mini-css-extract-plugin
module.exports = {"blockUi":"BlockUi_blockUi__1gcb5","spinner":"BlockUi_spinner__I3SsK","spinnerLabel":"BlockUi_spinnerLabel__1pz8k"};